/* eslint-disable react/no-children-prop */
import React from 'react';

const createBlockAlignmentButton = ({ alignment, children }) => {
  const BlockAlignmentButton = (props) => {
    const activate = (event) => {
      event.preventDefault();
      props.setAlignment({ alignment });
    };

    const preventBubblingUp = (event) => {
      event.preventDefault();
    };

    const isActive = () => props.alignment === alignment;

    const { theme } = props;
    const buttonStyle = isActive() ? [theme.button, theme.active] : theme.button;

    return (
      <div css={theme.buttonWrapper} onMouseDown={preventBubblingUp}>
        <button css={buttonStyle} onClick={activate} type='button' children={children} />
      </div>
    );
  };

  return BlockAlignmentButton;
};

export default createBlockAlignmentButton;
